import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ui-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css']
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() lettering = [];
  @Input() delay = 3500;

  constructor() { }

  ngOnInit() {
  }


}
